export const questions = [
  {
    id: 'q1',
    title: 'What type of business do you own?',
    type: 'single',
    options: [
      { id: 'retail', label: 'Retail store' },
      { id: 'restaurant', label: 'Restaurant / Food service' },
      { id: 'professional_services', label: 'Professional services (consultant, coach, etc.)' },
      { id: 'contractor', label: 'Contractor / Construction' },
      { id: 'home_based', label: 'Home-based business' },
      { id: 'ecommerce', label: 'E-commerce / Online business' },
      { id: 'healthcare', label: 'Healthcare / Medical practice' },
      { id: 'real_estate', label: 'Real estate agency' },
      { id: 'other', label: 'Other' },
    ]
  },
  {
    id: 'q2',
    title: 'How many employees do you have (including part-time)?',
    type: 'single',
    options: [
      { id: 'solo', label: 'Just me (solo business owner)' },
      { id: '1_5', label: '1-5 employees' },
      { id: '6_15', label: '6-15 employees' },
      { id: '16_50', label: '16-50 employees' },
      { id: '50_plus', label: '50+ employees' },
    ]
  },
  {
    id: 'q3',
    title: "What's your estimated annual revenue?",
    type: 'single',
    options: [
      { id: 'under_100k', label: 'Under $100K' },
      { id: '100k_250k', label: '$100K - $250K' },
      { id: '250k_500k', label: '$250K - $500K' },
      { id: '500k_1m', label: '$500K - $1M' },
      { id: '1m_5m', label: '$1M - $5M' },
      { id: 'over_5m', label: 'Over $5M' },
    ]
  },
  {
    id: 'q4',
    title: 'When did you last review your business insurance?',
    type: 'single',
    options: [
      { id: 'within_year', label: 'Within the past year' },
      { id: '1_2_years', label: '1-2 years ago' },
      { id: '3_5_years', label: '3-5 years ago' },
      { id: '5_plus_years', label: '5+ years ago' },
      { id: 'never', label: "Never had business insurance / Don't remember" },
    ]
  },
  {
    id: 'q5',
    title: 'Which types of business insurance do you currently have?',
    subtitle: 'Select all that apply',
    type: 'multiple',
    options: [
      { id: 'general_liability', label: 'General Liability' },
      { id: 'professional_liability', label: 'Professional Liability / Errors & Omissions (E&O)' },
      { id: 'commercial_property', label: 'Commercial Property' },
      { id: 'workers_comp', label: "Workers' Compensation" },
      { id: 'commercial_auto', label: 'Commercial Auto / Business Vehicle' },
      { id: 'cyber_liability', label: 'Cyber Liability' },
      { id: 'business_interruption', label: 'Business Interruption' },
      { id: 'epli', label: 'Employment Practices Liability (EPLI)' },
      { id: 'not_sure', label: 'Not sure what I have', exclusive: true },
      { id: 'none', label: "I don't have any business insurance", exclusive: true },
    ]
  },
  {
    id: 'q6',
    title: "What's your biggest concern about your business insurance?",
    type: 'single',
    options: [
      { id: 'paying_too_much', label: 'Paying too much for coverage' },
      { id: 'dont_have_enough', label: "Don't have enough coverage / worried about gaps" },
      { id: 'dont_understand', label: "Required by landlord/client but don't understand it" },
      { id: 'claim_denied', label: 'Had a claim denied or issue in the past' },
      { id: 'business_changed', label: "Business changed but insurance hasn't" },
      { id: 'dont_know_coverage', label: "Don't know what coverage I actually have" },
      { id: 'no_concerns', label: 'Everything seems fine / No concerns' },
    ]
  },
  {
    id: 'q7',
    title: 'Do any of these apply to your business?',
    subtitle: 'Select all that apply',
    type: 'multiple',
    options: [
      { id: 'store_customer_data', label: 'Store/handle customer data (credit cards, personal info)' },
      { id: 'physical_location', label: 'Have a physical office/storefront customers visit' },
      { id: 'use_vehicles', label: 'Use vehicles for business purposes' },
      { id: 'professional_advice', label: 'Give professional advice or consulting services' },
      { id: 'remote_employees', label: 'Have employees working remotely' },
      { id: 'expensive_equipment', label: 'Handle expensive equipment or inventory' },
      { id: 'clients_property', label: "Work with clients' property or data" },
      { id: 'manufacture_products', label: 'Manufacture or sell products' },
      { id: 'none', label: 'None of the above', exclusive: true },
    ]
  },
  {
    id: 'q8',
    title: 'Have you had any of these changes in the past year?',
    subtitle: 'Select all that apply',
    type: 'multiple',
    options: [
      { id: 'hired_employees', label: 'Hired new employees' },
      { id: 'increased_revenue', label: 'Increased revenue significantly (20%+)' },
      { id: 'moved_location', label: 'Moved to new location' },
      { id: 'added_services', label: 'Added new services/products' },
      { id: 'started_online', label: 'Started selling online' },
      { id: 'expanded_markets', label: 'Expanded to new markets/territories' },
      { id: 'bought_equipment', label: 'Bought expensive equipment' },
      { id: 'none', label: 'None of the above', exclusive: true },
    ]
  }
];